export default "__VITE_ASSET__DjAdaNBI__"